import { useEffect, useRef } from 'react';

const useEffectOnce = (callback) => {
  const hasRun = useRef(false);

  useEffect(() => {
    if (!hasRun.current) {
      callback();
      hasRun.current = true;
    }
  }, []);
};

export default useEffectOnce;


// import { useEffect } from 'react';

// const useEffectOnce = (effect) => {
//   useEffect(effect, []);
// };

// export default useEffectOnce;
